import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "leave_add"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NavBar = _resolveComponent("NavBar");
  const _component_van_field = _resolveComponent("van-field");
  const _component_van_uploader = _resolveComponent("van-uploader");
  const _component_van_cell_group = _resolveComponent("van-cell-group");
  const _component_van_button = _resolveComponent("van-button");
  const _component_van_form = _resolveComponent("van-form");
  const _component_van_date_picker = _resolveComponent("van-date-picker");
  const _component_van_time_picker = _resolveComponent("van-time-picker");
  const _component_van_picker_group = _resolveComponent("van-picker-group");
  const _component_van_popup = _resolveComponent("van-popup");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_NavBar, {
    title: "请假申请"
  }), _createVNode(_component_van_form, {
    ref: "formRef",
    onSubmit: _ctx.onSubmit
  }, {
    default: _withCtx(() => [_createVNode(_component_van_cell_group, {
      inset: ""
    }, {
      default: _withCtx(() => [_createVNode(_component_van_field, {
        modelValue: _ctx.name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.name = $event),
        required: "",
        readonly: "",
        "label-width": "100px",
        "input-align": "right",
        "error-message-align": "right",
        name: "name",
        label: "请假人员",
        placeholder: "请输入请假人员",
        rules: [{
          required: true,
          message: '请假人员不能为空'
        }]
      }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
        modelValue: _ctx.modelForm.beginTime,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.modelForm.beginTime = $event),
        required: "",
        clearable: "",
        readonly: "",
        "is-link": "",
        clickable: "",
        "label-width": "120px",
        "input-align": "right",
        "error-message-align": "right",
        name: "beginTime",
        label: "请假开始时间",
        placeholder: "请选择请假开始时间",
        rules: [{
          required: true,
          message: '请假开始时间不能为空'
        }],
        onClick: _cache[2] || (_cache[2] = $event => _ctx.handlerClcikTime('beginTime'))
      }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
        modelValue: _ctx.modelForm.endTime,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _ctx.modelForm.endTime = $event),
        required: "",
        clearable: "",
        readonly: "",
        "is-link": "",
        clickable: "",
        "label-width": "120px",
        "input-align": "right",
        "error-message-align": "right",
        name: "endTime",
        label: "请假截止时间",
        placeholder: "请选择请假截止时间",
        rules: [{
          required: true,
          message: '请假截止时间不能为空'
        }],
        onClick: _cache[4] || (_cache[4] = $event => _ctx.handlerClcikTime('endTime'))
      }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
        modelValue: _ctx.modelForm.reason,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _ctx.modelForm.reason = $event),
        border: false,
        class: "remark",
        autosize: "",
        clearable: "",
        required: "",
        rows: "2",
        label: "请假事由",
        type: "textarea",
        maxlength: "100",
        placeholder: "请输入请假事由",
        "label-align": "top",
        "show-word-limit": "",
        rules: [{
          required: true,
          message: '请假事由不能为空'
        }]
      }, null, 8, ["modelValue"]), _cache[12] || (_cache[12] = _createElementVNode("div", {
        style: {
          "height": "10px",
          "background-color": "#f8faff"
        }
      }, null, -1)), _createVNode(_component_van_field, {
        modelValue: _ctx.modelForm.attachment,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => _ctx.modelForm.attachment = $event),
        border: false,
        required: "",
        class: "noShow",
        "label-align": "top",
        name: "attachment",
        label: "附件"
      }, {
        input: _withCtx(() => [_createVNode(_component_van_uploader, {
          modelValue: _ctx.fileList,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => _ctx.fileList = $event),
          style: {
            "margin-left": "7px"
          },
          ref: "upload",
          accept: "image/*",
          "max-count": 1,
          "max-size": 10 * 1024 * 1024,
          "before-read": _ctx.beforeRead,
          "after-read": _ctx.afterRead,
          onOversize: _ctx.onOversize
        }, null, 8, ["modelValue", "before-read", "after-read", "onOversize"])]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_van_button, {
      class: "submit",
      block: "",
      loading: _ctx.loading,
      "loading-text": "提交中...",
      disabled: _ctx.loading,
      type: "primary",
      "native-type": "submit"
    }, {
      default: _withCtx(() => _cache[13] || (_cache[13] = [_createTextVNode(" 提交 ")])),
      _: 1
    }, 8, ["loading", "disabled"])]),
    _: 1
  }, 8, ["onSubmit"]), _createVNode(_component_van_popup, {
    show: _ctx.showPicker,
    "onUpdate:show": _cache[11] || (_cache[11] = $event => _ctx.showPicker = $event),
    position: "bottom"
  }, {
    default: _withCtx(() => [_createVNode(_component_van_picker_group, {
      tabs: ['选择日期', '选择时间'],
      onConfirm: _ctx.onConfirm,
      onCancel: _cache[10] || (_cache[10] = $event => _ctx.showPicker = false)
    }, {
      default: _withCtx(() => [_createVNode(_component_van_date_picker, {
        modelValue: _ctx.currentDate,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => _ctx.currentDate = $event),
        formatter: _ctx.formatter
      }, null, 8, ["modelValue", "formatter"]), _createVNode(_component_van_time_picker, {
        modelValue: _ctx.currentTime,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => _ctx.currentTime = $event),
        formatter: _ctx.formatter
      }, null, 8, ["modelValue", "formatter"])]),
      _: 1
    }, 8, ["onConfirm"])]),
    _: 1
  }, 8, ["show"])]);
}